<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :click-not-close="true"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="menu-do-dialog"
  >
    <div class="form-content">
      <menu-form
        ref="outform"
        :menu-id="menuId"
        :form-data="formData"
        @submit="submit"
      ></menu-form>
    </div>
  </sliderBarDialogShell>
</template>

<script>
import { queryMenuDetail,editMenu } from "@/api/sys/menu";
import menuForm from "@/components/sys/menu/menuForm";
export default {
  name: "editDialog",
  components: {
    menuForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    menuId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      title: '编辑菜单',
      formData: {}
    }
  },
  watch:{
    menuId(val){
      this.getFormData(val);
    },
  },
  methods: {
    getFormData(id){
      queryMenuDetail(id).then((data) => {
        this.formData = data.menu;
      })
    },
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel(){
      this.beforeClose();
    },
    confirm(){
      this.$refs.outform.selfValidate();
    },
    submit(form){
      let params = {
        menuId: form.id,
        'type': form.type,
        'name': form.name,
        'parentId': form.parentId,
        'url': form.url,
        'perms': form.perms,
        'orderNum': form.orderNum,
        'icon': form.icon
      }
      editMenu(params).then((data) => {
        if(data && data.code===200){
          this.$message({
            message: '编辑成功',
            type: 'success',
          });
          this.$emit('edit-success');
        }else{
          this.$message({
            message: data.msg,
            type: 'error'
          });
        }
      }).catch((err) => {
        // this.$message.error(err.msg)
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .menu-do-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
